export const pages = {
  en: {
    home: "Home",
    crumbs: "Home",
    programmes: {
      eyebrow: "Programmes", title: "Online and distance programmes, explained honestly",
      text: "See the programmes we guide on, the universities we compare, how counselling works, and how to verify a programme before you apply.",
      sub: [["programs", "Courses"], ["universities", "Universities"], ["how-it-works", "How it works"], ["who-for", "Who it's for"], ["funding", "EMI & scholarships"], ["verify", "Verify"]],
      subLabel: "On this page",
    },
    contact: {
      eyebrow: "Contact", title: "We're here to help",
      text: "Call, WhatsApp or email us, or fill in the form and a counsellor will get back to you.",
      cards: { call: "Call us", whatsapp: "WhatsApp", email: "Email", visit: "Visit us" },
    },
    teaser: { all: "View all programmes" },
    explore: {
      eyebrow: "Explore", title: "Find what you need",
      items: [
        { to: "/programmes", title: "Programmes & universities", text: "Courses, universities, EMI and scholarship guidance, and how to verify before you apply." },
        { to: "/about", title: "About us", text: "Since 2012, 7,000+ students guided. Our story, values and admission process." },
        { to: "/contact", title: "Contact & FAQ", text: "Book free counselling, get answers to common questions or find our Lucknow office." },
      ],
    },
  },
  hi: {
    home: "होम",
    crumbs: "होम",
    programmes: {
      eyebrow: "प्रोग्राम", title: "ऑनलाइन और डिस्टेंस प्रोग्राम, ईमानदारी से समझाए गए",
      text: "जिन प्रोग्राम्स पर हम मार्गदर्शन देते हैं, जिन यूनिवर्सिटी की तुलना करते हैं, काउंसलिंग कैसे होती है, और अप्लाई करने से पहले प्रोग्राम कैसे जाँचें, यहाँ देखें।",
      sub: [["programs", "कोर्स"], ["universities", "यूनिवर्सिटी"], ["how-it-works", "कैसे काम करता है"], ["who-for", "किसके लिए"], ["funding", "EMI और स्कॉलरशिप"], ["verify", "जाँच"]],
      subLabel: "इस पेज पर",
    },
    contact: {
      eyebrow: "संपर्क", title: "हम मदद के लिए यहाँ हैं",
      text: "हमें कॉल, WhatsApp या ईमेल करें, या फ़ॉर्म भरें, काउंसलर आपसे संपर्क करेंगे।",
      cards: { call: "कॉल करें", whatsapp: "WhatsApp", email: "ईमेल", visit: "हमसे मिलें" },
    },
    teaser: { all: "सभी प्रोग्राम देखें" },
    explore: {
      eyebrow: "और देखें", title: "जो चाहिए, वह यहाँ पाएँ",
      items: [
        { to: "/programmes", title: "प्रोग्राम और यूनिवर्सिटी", text: "कोर्स, यूनिवर्सिटी, EMI और स्कॉलरशिप मार्गदर्शन, और अप्लाई करने से पहले जाँच कैसे करें।" },
        { to: "/about", title: "हमारे बारे में", text: "2012 से, 7,000+ स्टूडेंट्स का मार्गदर्शन। हमारी कहानी, मूल्य और एडमिशन प्रक्रिया।" },
        { to: "/contact", title: "संपर्क और सवाल-जवाब", text: "मुफ़्त काउंसलिंग बुक करें, आम सवालों के जवाब पाएँ या हमारा लखनऊ ऑफ़िस खोजें।" },
      ],
    },
  },
};
